import { render, staticRenderFns } from "./Violation.vue?vue&type=template&id=5d1bf02e&scoped=true&"
import script from "./Violation.vue?vue&type=script&lang=js&"
export * from "./Violation.vue?vue&type=script&lang=js&"
import style0 from "./Violation.vue?vue&type=style&index=0&id=5d1bf02e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1bf02e",
  null
  
)

export default component.exports